var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmptyStateChart"},[_c('div',{staticClass:"border"},[_c('div',{staticClass:"content"},[_c('h5',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t")]),_c('p',{staticClass:"caption"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.caption)+"\n\t\t\t\t\t")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }